import Booking from '../Components/Booking/Booking';

const About = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div className="relative h-[200px] sm:h-[300px] w-full">
        <div className="absolute inset-0">
          <img 
            src={'/static/images/pagesBg/about.jpg'}
            alt="Spa Interior"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/40"></div>
        </div>
        <div className="relative h-full flex items-center justify-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl text-white font-semibold text-center px-4">
            About Piel Perfecta
          </h1>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-16">
        <div className="space-y-6 sm:space-y-8 sm:px-8 -mt-8 pt-2 md:pt-0">
          <p className="text-base sm:text-lg text-dim-light px-4 sm:px-0">
            Welcome to <span className="font-semibold">Piel Perfecta</span>, where luxury meets skincare 
            excellence. Our spa is dedicated to helping you achieve radiant, healthy skin through 
            personalized treatments designed to rejuvenate and restore. With a focus on premium products, 
            advanced techniques, and a tranquil atmosphere, we offer a wide range of services, from 
            revitalizing facials to soothing massages.
          </p>
          
          <p className="text-base sm:text-lg text-dim-light px-4 sm:px-0">
            At <span className="font-semibold">Piel Perfecta</span>, self-care is more than a routine, 
            it's a lifestyle. Experience the perfect balance of relaxation and results. 
            <span className="italic"> Your journey to flawless skin begins here.</span>
          </p>
        </div>

        {/* Booking Component */}
        <div className="mt-8 sm:mt-16">
          <Booking />
        </div>
      </div>
    </div>
  );
};

export default About;